import { Box, Button, Grid, Switch, Tooltip } from '@mui/material';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import React, { FC, useEffect, useState } from 'react';
import { SCUIContent } from '../../atomic/organisms';
import { OrderQuery } from '../../services/query';
import EditIcon from '@mui/icons-material/EditSharp';
import { SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { SCUIShippingCancelReasonUpdateDrawer } from './components/SCUIShippingCancelReasonUpdateDrawer';
import { SCUIButton, SCUILoadingLinear } from '../../atomic/atoms';
import { useTranslation } from 'react-i18next';
import { SCRN } from './shippingCancelReason.classes';

export const ShippingCancelReason: FC<any> = () => {
    const { t } = useTranslation();
    const [state, setState] = React.useState({
        right: false,
    });
    const onDrawerOpen = () => setState({ ...state, right: true });
    const onDrawerClose = () => setState({ ...state, right: false });
    const [shippingList, setShippingList] = React.useState([]);
    const [shippingRow, setShippingRow] = React.useState<any>();
    const [refresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const refreshShippingList = () => {
        setRefresh((prevLoading) => !prevLoading);
    };
    const GetShippingListCancelReason = () => {
        setLoading(true);
        OrderQuery.GetShippingListCancelReason()
            .then((res: any) => {
                if (res) {
                    let parseData = res.map((item: any) => {
                        return {
                            reasonId: item.reasonId || '-',
                            reasonKey: item.reasonKey || '',
                            reasonName: item.reasonName || '-',
                            isActive: item.isActive || false,
                            isDeleted: item.isDeleted || false,
                            reasonPriorityId: item.reasonPriorityId || 0,
                        };
                    });
                    setShippingList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const columns: ExtendedGridColDef[] = [
        {
            field: 'reasonId',
            headerName: t('orderCancellationReasons.reasonId'),
            flex: 1,
            renderCell: (params: any) => (
                <span className={SCRN.cellReasonId} data-reason-id={params.row.reasonId}>
                    {params.row.reasonId}
                </span>
            ),
        },
        {
            field: 'reasonKey',
            headerName: t('orderCancellationReasons.reasonKey'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <Tooltip title={<h2>{params.row.reasonKey}</h2>}>
                        <p
                            className={`${SCRN.cellReasonKey} ${SCRN.cellReasonKeyText}`}
                            data-reason-id={params.row.reasonId}
                            data-reason-key={params.row.reasonKey}
                        >
                            {params.row.reasonKey}
                        </p>
                    </Tooltip>
                );
            },
        },
        {
            field: 'reasonName',
            headerName: t('orderCancellationReasons.reasonName'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <Tooltip title={<h2>{params.row.reasonName}</h2>}>
                        <p
                            className={`${SCRN.cellReasonName} ${SCRN.cellReasonNameText}`}
                            data-reason-id={params.row.reasonId}
                            data-reason-name={params.row.reasonName}
                        >
                            {params.row.reasonName}
                        </p>
                    </Tooltip>
                );
            },
        },
        {
            field: 'isActive',
            headerName: t('general.active'),
            flex: 1,
            renderCell: (params: any) => {
                const checked = params.row.isActive === true;
                return (
                    <div className={SCRN.cellIsActive}>
                        <Switch
                            className={SCRN.inputCellIsActiveSwitch}
                            data-reason-id={params.row.reasonId}
                            data-is-active={String(checked)}
                            checked={checked}
                        ></Switch>
                    </div>
                );
            },
        },
        {
            field: 'isDeleted',
            headerName: t('shippingCancelReason.isDeleted'),
            flex: 1,
            renderCell: (params: any) => {
                const checked = params.row.isDeleted === true;
                return (
                    <div className={SCRN.cellIsDeleted}>
                        <Switch
                            className={SCRN.inputCellIsDeletedSwitch}
                            data-reason-id={params.row.reasonId}
                            data-is-deleted={String(checked)}
                            checked={checked}
                        ></Switch>
                    </div>
                );
            },
        },
        {
            field: 'reasonPriorityId',
            headerName: t('shippingCancelReason.reasonPriorityId'),
            flex: 1,
            renderCell: (params: any) => (
                <span
                    className={SCRN.cellReasonPriorityId}
                    data-reason-id={params.row.reasonId}
                    data-priority-id={params.row.reasonPriorityId}
                >
                    {params.row.reasonPriorityId}
                </span>
            ),
        },
        {
            field: 'edit',
            headerName: t('general.edit'),
            flex: 1,
            renderCell: (params) => {
                const onclick = () => {
                    onDrawerOpen();
                    setShippingRow(params.row);
                };
                return params.row.isDeleted === true ? (
                    <div className={SCRN.cellEdit}>
                        <Button
                            onClick={onclick}
                            className={SCRN.btnEdit}
                            data-reason-id={params.row.reasonId}
                            data-reason-key={params.row.reasonKey}
                        >
                            <EditIcon fontSize="large" />
                        </Button>
                    </div>
                ) : (
                    ''
                );
            },
        },
    ];
    useEffect(() => {
        GetShippingListCancelReason();
    }, [refresh]);
    return (
        <SCUIContent className={SCRN.page}>
            <Box className={SCRN.root}>
                <Grid
                    container
                    spacing={6}
                    sx={{ marginBottom: '1rem', marginTop: '1rem' }}
                    className={SCRN.header}
                    size={{
                        md: 12,
                        xs: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <Grid
                        className={SCRN.titleBox}
                        spacing={6}
                        size={{
                            md: 12,
                            xs: 12,
                            lg: 6,
                            xl: 6,
                        }}
                    >
                        <h1 className={`headtxt ${SCRN.title}`}>
                            <b>{t('orderCancellationReasons.pageTitle')}</b>
                        </h1>
                    </Grid>
                    <Grid
                        className={SCRN.headerActions}
                        sx={{ display: 'flex', justifyContent: 'end' }}
                        size={{
                            xl: 6,
                            lg: 6,
                            md: 12,
                            xs: 6,
                        }}
                    >
                        <SCUIButton
                            className={SCRN.btnAdd}
                            text={t('general.add')}
                            type="primary"
                            sizeType="fixed"
                            size={'m'}
                            buttonType="button"
                            onClick={() => {
                                onDrawerOpen();
                                setShippingRow([]);
                            }}
                        />
                    </Grid>
                </Grid>
                <Box className={SCRN.loading}>
                    <SCUILoadingLinear display={loading} />
                </Box>
                <Box className={SCRN.drawer}>
                    <SCUIGeneralDrawer
                        open={state['right']}
                        anchor="right"
                        width={'40rem'}
                        onClose={(_: any, reason: any) => {
                            if (reason === 'backdropClick') {
                                setState({ ...state, right: false });
                            }
                        }}
                    >
                        <SCUIShippingCancelReasonUpdateDrawer
                            selectedRow={shippingRow}
                            onClose={onDrawerClose}
                            refresh={refreshShippingList}
                        />
                    </SCUIGeneralDrawer>
                </Box>
                <Grid
                    className={SCRN.grid}
                    sx={{ marginRight: '1.5rem' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <SCUICustomDataGrid rows={shippingList} columns={columns} randomId />
                </Grid>
            </Box>
        </SCUIContent>
    );
};
